import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    CircularProgress,
    Grid,
    Typography
} from '@material-ui/core'

const useStyles = makeStyles(() => ({
    content: {
        height: "100vh"
    },
    text: {
        paddingRight: 5
    }
}))

const CheckingLogin = ({ error }) => {
    const classes = useStyles()
    return (
        <Grid container justifyContent="center" alignItems="center" className={classes.content}>
            {
                !error ?
                    <React.Fragment>
                        <Typography className={classes.text}>Checking login</Typography>
                        <CircularProgress />
                    </React.Fragment>
                    :
                    <Typography>Login failed {String(error)}</Typography>
            }
        </Grid>
    )
}

export default CheckingLogin